import { Injectable, inject } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, ValidatorFn } from '@angular/forms';

import { RequiredValidator } from '@app-core/validations';
import { DecodeVinResponse } from '@app-model/api';
import { Field } from '@app-model/form';
import { ControlDateFormatter } from '@app-shared/utils';

import { ValidationService } from './validation.service';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  private formBuilder = inject(NonNullableFormBuilder);

  // CONVERT FIELD ARRAY TO FORM GROUP
  setForm(response: Field[]): FormGroup {
    const form: FormGroup = this.formBuilder.group({});
    response.forEach((element) => {
      if (element.display) {
        const field = this.setDefault(element);
        const validations = this.getValidations(element);
        field.setValidators(validations);
        form.addControl(element.name, field);
      }
    });
    ValidationService.BusinessFieldValidate(form);

    return form;
  }

  setProductFormAfterVinDecodedSuccessfully(productForm: FormGroup, vinData: DecodeVinResponse): void {
    productForm.get('vin').setValue(vinData.vin);
    productForm.get('year').setValue(vinData.year[0]);
    productForm.get('make').setValue(vinData.make[0]);
    productForm.get('model').setValue(vinData.model[0]);
    productForm.get('trim').setValue('');

    productForm.get('inServiceDate')?.enable();

    productForm.get('vin').disable();
    // set inservice date
    if (vinData.inserviceDateFound) {
      const insDate = ControlDateFormatter.encode(vinData.inserviceDate);
      productForm.get('inServiceDate')?.patchValue(insDate);
      productForm.get('inServiceDate')?.disable();
    } else {
      productForm.get('inServiceDate')?.patchValue(null);
    }
  }

  setProductFormForManualDecode(productForm: FormGroup): void {
    productForm?.get('year').setValue('');
    productForm?.get('make').setValue('');
    productForm?.get('model').setValue('');
    productForm?.get('trim')?.setValue('');

    productForm?.get('inServiceDate')?.enable();
  }

  private setDefault(element: Field): FormControl {
    const field = new FormControl();
    field['label'] = element.label;
    field.setValue(element.default);
    if (element.readOnly) {
      field.disable();
    }
    // only for tax fields
    if (element['taxPercentage']) {
      field['taxPercentage'] = element['taxPercentage'] / 100.0;
    }

    return field;
  }

  private getValidations(element: Field): ValidatorFn[] {
    let validations: ValidatorFn[] = [];
    if (element.required) {
      validations.push(RequiredValidator);
    }

    element.validations.forEach((elementValidation) => {
      // running all validations from validation.service with switch statement
      validations = ValidationService.addValidation(validations, elementValidation);
    });

    return validations;
  }
}
